import { render, staticRenderFns } from "./CardPlainNav.vue?vue&type=template&id=478c7beb"
import script from "./CardPlainNav.vue?vue&type=script&lang=js"
export * from "./CardPlainNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports